import { render, staticRenderFns } from "./PlanejamentoEdicaoAcaoForm.vue?vue&type=template&id=32342e4e&"
import script from "./PlanejamentoEdicaoAcaoForm.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoEdicaoAcaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports